export default __webpack_public_path__ + "static/media/house.58d17eef.svg";